import { Injectable, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Sgkb981aRequest, Sgkb981aReqSyuseiInfoDto, Sgkb981aReqFtiGoodsDto,
        Sgkb981aResponse, SGKB981AService } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { MoneyFormatService } from '../../../../../sg-base/sg-base-shared/services/money-format.service';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb981aService {

  /** Response情報 */
  sgkb981aResponse: Sgkb981aResponse;

  /**
   * Constractor
   * Creates an instance of UsedSgkb981aService.
   * @param {SGKB981AService} sGKB981AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {MoneyFormatService} moneyFormatService
   * @memberof UsedSgkb981aService
   */
  constructor(private sGKB981AService: SGKB981AService, private apiCommonService: ApiCommonService, private timeApiService: TimeApiService, private moneyFormatService: MoneyFormatService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }


  /**
  * 契約修正 API呼び出し
  *
  * @param {*} value
  * @return {*}  {Sgkb981aResponse}
  * @memberof UsedSgkb981aService
  */
  insertCustomer(value: any): Observable<Sgkb981aResponse> {

    //Reqeust info
    let request: Sgkb981aRequest = {
      requestCommon: value.requestCommon,
      syuseiInfo: this.createSyuseiInfo(value),
      ftiGoodsInfo: {
        ftiGoodsList: this.createFtiGoodsInfo(value)
      },
    };

    // 年月日項目のフォーマット
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

    return this.sGKB981AService.SGKB981APost(<Sgkb981aRequest>this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_FF, SgkbConstains.MESSAGE.APINAME_SGKB981A);
          return throwError(err.message);
        })
      );
  }

  /**
   * 修正情報 生成
   * @param value
   * @returns
   */
  private createSyuseiInfo(value: any): Sgkb981aReqSyuseiInfoDto {
    // 調整単位料金おしらせ発行フラグ（リクエスト設定用）
    let setValNoticeOfAdjustmentUnitChargeIssueFlg: string = '0';
    // 調整単位料金おしらせ発行フラグにチェックがある場合
    if (value.noticeOfAdjustmentUnitChargeIssueFlg) {
      setValNoticeOfAdjustmentUnitChargeIssueFlg = '1';
    }

    // 冷房能力（リクエスト設定用）
    let setCoolAbility: number = 0;
    setCoolAbility = this.numberComma(value.coolAbility);

    // 発電容量（リクエスト設定用）
    let setGeneratCapacity: number = 0;
    setGeneratCapacity = this.numberComma(value.generatCapacity);

    // 定格入力値（合計）（リクエスト設定用）
    let setPreRatedInputValue: number = 0;
    setPreRatedInputValue = this.numberComma(value.preRatedInputValue);

    // 満了予定年月のハイフン除去
    let setexpirationMon = value.expirationMon.replace('年', '');
    setexpirationMon = setexpirationMon.replace('月', '');
    // 初回検針年月のハイフン除去
    let setFirstMeterReadMon = value.firstMeterReadMon.replace('-', '');

    let syuseiInfo: Sgkb981aReqSyuseiInfoDto = {
      // 契約お客さま番号
      firstSrvctrNo: value.firstSrvctrNo,
      // サービス契約番号
      srvCtrNo: value.srvCtrNo,
      // 更新通番号
      updateSrno: value.updateSrno,
      // 契約締結組織番号
      tantoSosikiId: value.contractDepartmentCategory,
      // 契約締結社員番号
      tantoStaffNo: value.contractManagerCategory,
      // お客さま契約窓口担当部署
      visitMadoguchiTantobusho: value.customerDepartment,
      // お客さま契約窓口担当者
      visitMadoguchiTntsh: value.customerManager,
      // 契約開始日付
      ctrstrDate: this.timeApiService.convertDateToString(value.appliStartDate),
      // 満了予定年月
      expireScheduleyearmonth: setexpirationMon,
      // 契約終了日付
      ctrendDate: this.decisionAppliEndDate(value.appliEndDate),
      // サービス契約締結日付
      prdCtrDate: this.timeApiService.convertDateToString(value.agreementDate),
      // 初回検針年月
      firstInspectionyearmonthday: setFirstMeterReadMon,
      // 契約書受領日
      ctrdocReceiptdate: this.timeApiService.convertDateToString(value.receiptDate),
      // 冷房能力
      reiboability: setCoolAbility,
      // 発電容量
      powergenerationcapacity: setGeneratCapacity,
      // 定格入力値（合計）
      ratedinputvalueSum: setPreRatedInputValue,
      // 空調
      airconditioning: value.airControlFlg,
      // 機器定格
      deviceTeikaku: value.deviceFlg,
      // 基本契約締結日付
      basiccontractConclusiondate: this.timeApiService.convertDateToString(value.basicAgreementDate),
      // 基本契約書受領日付
      basiccontractdocumentReceiptdate: this.timeApiService.convertDateToString(value.basicReceiptDate),
      // 独自管理対象個別コード
      independentmanagementTargetIndividualcode: value.IndManageSign,
      // 停止時要配慮フラグ
      duringstopAttentionrequiredflag: value.attentionOnStopFlagCategory,
      // 調整単位料金おしらせ発行フラグ
      adjustmentunitfeeNoticeHakkoflag: setValNoticeOfAdjustmentUnitChargeIssueFlg,
      // 関連会社区分
      relatedcompanyDiv: value.kanrengaisyaCategory,
      // 関連会社お客さま番号
      relatedcompanyVisitornumber: value.kanrengaisyaOkyakusamaNo,
    }

    return syuseiInfo;
  }

  /**
   * カンマ除去
   */
  numberComma(targetItem: string): number {
    let targetMoney: string = targetItem;
    let noCommatMoney: string = this.moneyFormatService.reformatMoney(targetMoney);

    return +noCommatMoney;
  }

  /**
   * 付帯契約情報　作成
   *
   * @private
   * @return {*}  {Szoa201aRequestAceptInfo}
   * @memberof UsedSgkb981aService
   */
  private createFtiGoodsInfo(value: any): Array<Sgkb981aReqFtiGoodsDto> {
    let ftiGoodsList: Array<Sgkb981aReqFtiGoodsDto> = [];

    value.items.forEach((ftiGoodsInfo) => {
      // 満了予定年月のハイフン除去
      let setExpScheduleMonth = null;
      if(ftiGoodsInfo.expScheduleMonth && ftiGoodsInfo.expScheduleMonth != ''){
        setExpScheduleMonth = ftiGoodsInfo.expScheduleMonth.replace('-', '');
      }
      // 適用開始日付の整形
      let opeStartMonth = null;
      if(ftiGoodsInfo.opeStartMonth && ftiGoodsInfo.opeStartMonth != null){
        opeStartMonth = this.timeApiService.convertDateToString(ftiGoodsInfo.opeStartMonth);
      }
      let ftiGoods: Sgkb981aReqFtiGoodsDto = {
        // 商品コード
        goodsCode: ftiGoodsInfo.ftGoodsCode,
        // 適用開始日付
        applyStartDate: opeStartMonth,
        // 満了予定年月
        expireScheduleyearmonth: setExpScheduleMonth,
        // 継続年数
        duration: ftiGoodsInfo.continuYears,
      };
      ftiGoodsList.push(ftiGoods);
    });
    return ftiGoodsList;
  }

  /**
   * 契約終了日判定
   */
  decisionAppliEndDate(appliEndDate: Date): string {
    // 契約終了日をDate型からstring型に変換
    let targetDate: string = this.timeApiService.convertDateToString(appliEndDate)
    // 契約終了日が99991231でなければ契約終了日をそのまま返却
    if(targetDate != '99991231'){
      return targetDate;
    }
    // 空を返却
    return '';
  }
}